import DinotRegular from '../assets/fonts/dinot/DINOT.otf';
import GutonRegular from '../assets/fonts/guton/Guton-Regular.otf';
import VolkThin from '../assets/fonts/volkolak/VolkolakGrotesque-Thin.ttf';

export const globalFonts = [
  {
    '@font-face': [
      {
        fontFamily: 'Guton',
        src: `url(${GutonRegular}) format('opentype')`,
        fontWeight: 400,
        fontStyle: 'normal',
        fontDisplay: 'swap',
      },
    ]
  },
  {
    '@font-face': [
      {
        fontFamily: 'Volk',
        src: `url(${VolkThin}) format('truetype')`,
        fontWeight: 300,
        fontStyle: 'normal',
        fontDisplay: 'swap',
      },
    ]
  },
  {
    '@font-face': [
      {
        fontFamily: 'DINOT',
        src: `url(${DinotRegular}) format('opentype')`,
        fontWeight: 400,
        fontStyle: 'normal',
        fontDisplay: 'swap',
      },
    ]
  }
] as const;
